import AsyncSelect from "react-select/async";
import classes from "./SelectInput.module.css";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { mergeClass } from "@/utils/helper";

const SelectInput = ({
  label,
  containerClassName = null,
  className = "",
  variant = "",
  errorText = "",
  hintText = "",
  required = true,
  ...props
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "auto",
      border: state.isDisabled
        ? "0.5px solid var(--gray-v5)"
        : "0.5px solid var(--blue-dark)",
      boxShadow: "none",
      backgroundColor: "var(--white-color)",
      borderRadius: "5px",
      fontFamily: "var(--inter)",
      fontSize: "16px",
      fontWeight: "300",
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      zIndex: 99999999,
      "&:hover": {
        border: state.isDisabled
          ? "0.5px solid var(--gray-v5)"
          : "0.5px solid var(--blue-dark)",
      },
    }),
    placeholder: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    input: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 999999999,
    }),
  };

  return (
    <div>
      <div
        className={mergeClass(containerClassName, classes.dropdownContainer)}
      >
        <label
          htmlFor={`input${label}`}
          style={{ color: props.isDisabled ? "var(--gray-v5)" : "" }}
        >
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        <div className={mergeClass(classes.inputPassContainer)}>
          <AsyncSelect
            id={`input${label}`}
            styles={customStyles}
            className={mergeClass(classes.dropdown)}
            menuPortalTarget={document.body}
            {...props}
          />
        </div>
      </div>
      {hintText && (
        <div className={`${classes.Container}`} data-variant={variant}>
          <div></div>
          <div className="mt-2 ml-[170px] mb-2 w-[450px]">{hintText}</div>
        </div>
      )}
      {errorText && (
        <div className={`${classes.Container}`} data-variant={variant}>
          <div></div>
          <div className={`mt-2 ${classes.errorText}`}>{errorText + "*"}</div>
        </div>
      )}
    </div>
  );
};

export default SelectInput;
